import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=3a0f95dc&scoped=true&"
import script from "./RegistrationModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0f95dc",
  null
  
)

export default component.exports